import { syncTeams } from "../../apis/teams";
import { atomWithQuery } from "jotai-tanstack-query";
import { authAtom } from "../auth/atoms";
import { Storage } from "../../storage";

export const userTeamsAtom = atomWithQuery((get) => ({
  queryKey: ["syncTeams", get(authAtom)?.data?.accessToken],
  queryFn: async ({ queryKey: [, accessToken] }) => {
    const teams = await syncTeams(Storage.getCurrentUserToken() || "");
    return teams;
  },
  enabled: false,
}));
